var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-flex align-items-center mr-2",
      attrs: {
        id: "lock-container",
        "aria-hidden": "true",
        "data-toggle": "tooltip",
        "data-placement": "left",
        "data-original-title": _vm.title,
      },
    },
    [
      _c("i", {
        staticClass: "clickable fa lock-button text-primary mx-1",
        class: _vm.iconClass,
        on: { click: _vm.handleClick },
      }),
      _vm._v(" "),
      _c("application-lock-modal", {
        ref: "lockModal",
        attrs: {
          locked: _vm.locked,
          "client-username": _vm.clientUsername,
          "application-id": _vm.applicationId,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }